(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name Security.constant:AuthEvents
   *
   * @description
   *
   */
  angular
    .module('Security')
    .constant('AuthEvents', {
      loginSuccess: 'event:auth-loginConfirmed',
      loginFailed: 'event:auth-loginFailed',
      loginCancelled: 'event:auth-loginCancelled',
      logoutSuccess: 'event:auth-logoutSuccess',
      sessionTimeout: 'event:auth-sessionTimeout',
      sessionLoaded: 'event:auth-sessionLoaded',
      notAuthenticated: 'event:auth-loginRequired',
      notAuthorised: 'event:auth-notAuthorised'
    });

})();
